import React, { FC, ReactElement } from "react";
import styled from "styled-components";
import { colorBlack } from "lib/constants";

interface Props {
  color?: string;
  children: ReactElement;
}

const FormAttentionWrap: FC<Props> = ({ color, children }) => (
  <AttentionWrap color={color}>{children}</AttentionWrap>
);

const AttentionWrap = styled.span<{ color?: string }>`
  color: ${(props) => props.color || colorBlack[400]};
  background: ${colorBlack[30]};
  border-radius: 20px;
  font-weight: 700;
  font-size: 14px;
  line-height: 22px;
  padding: 3px 16px;
`;

export default FormAttentionWrap;
